<template>
    <div class="history">
        <lgn-input class="history-search" placeholder="請輸入硬體資訊" v-model="searchText" 
        :suffix="true" :suffix-icon="'el-icon-search'" :suffix-method="searchHistory"
        @keyup.enter.native="searchHistory"></lgn-input>
        <div class="history-data paca-table">
            <div class="paca-table__header">
                <div class="paca-table__header-item item-column column-site-name">{{$t("table.header.siteName")}} ({{historyList.length}})</div>
                <div class="paca-table__header-item item-column column-site-code">{{$t("table.header.site")}}</div>
                <div class="paca-table__header-item item-column column-ip">{{$t("table.header.ip")}}</div>
                <div class="paca-table__header-item item-column column-create-time">{{$t("table.header.createTime")}}</div>
                <div class="paca-table__header-item item-column column-update-time">{{$t("table.header.updateTime")}}</div>
                <div class="paca-table__header-item item-column column-status"></div>
            </div>
            <div class="paca-table__body" v-if="viewHistoryList.length != 0">
                <div class="paca-table__body-col" v-for="(item, index) in viewHistoryList" :key="index">
                    <div class="paca-table__body-col-list">
                        <div class="paca-table__body-col-list-item item-column column-site-name overflow-text">{{item.name}}</div>
                        <div class="paca-table__body-col-list-item item-column column-site-code overflow-text">{{item.site}}</div>
                        <div class="paca-table__body-col-list-item item-column column-ip"><span class="item-column-mobile-text">IP 位置</span>{{item.ip}}</div>
                        <div class="paca-table__body-col-list-item item-column column-create-time"><span class="item-column-mobile-text">建立時間</span>{{item.created}}</div>
                        <div class="paca-table__body-col-list-item item-column column-update-time"><span class="item-column-mobile-text">更新時間</span>{{item.updated}}</div>
                        <div class="paca-table__body-col-list-item item-column column-status">
                            <el-select v-model="item.status" disabled>
                                <el-option v-for="(statusItem,statusIndex) in regListStatus" :key="statusIndex" :label="statusItem.key" :value="statusItem.value"></el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <button type="button" class="paca-table__body-more" v-if="isShowMoreButton" @click="historyListIteration()">更多</button>
            </div>
            <div class="paca-table__empty" v-else></div>
        </div>
    </div>
</template>
<script>
import * as api from "@/script/apiService/api.js"
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
import * as regListMapping from '@/script/regListMapping/regListMapping.js'
export default {
    name: "history",
    components: {
        lgnInput
    },
    data(){
        return {
            searchText: '',
            historyList: [],
            viewHistoryList: [],
            regListStatus: regListMapping.getRegSystemStatusMappingList(),
            viewMoreCount: 0,
            isShowMoreButton: true,
            tableLoading: false
        }
    },
    methods: {
        async searchHistory(){
            if(this.searchText.trim().length == 0){
                this.$message.error({
                    showClose: true,
                    duration: 2500,
                    message: "請輸入關鍵字!"
                })
                return false;
            }
            this.viewMoreCount = 0;
            this.isShowMoreButton = true;
            this.viewHistoryList = [];
            this.$nextTick(() => {
                this.tableLoading = true;
            })
            let res = await api.postAdminHistorySearch(this.searchText);
            if(!res.error_status){
                setTimeout(function(){
                    this.historyList = res;
                    this.tableLoading = false;
                    setTimeout(function(){
                        this.historyListIteration();
                    }.bind(this), 300);
                }.bind(this), 300);
                
            }else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤"
                })
            }
        },
        historyListIteration(){
            if((this.viewMoreCount + 1)*30 >= this.historyList.length){
                this.isShowMoreButton = false;
            }
            this.viewHistoryList = this.viewHistoryList.concat(this.historyList.slice(this.viewMoreCount*30, (this.viewMoreCount + 1) * 30));
            this.viewMoreCount += 1;
        },
    },
    watch: {
        tableLoading(value){
            let hasData = document.querySelector(".paca-table__body");
            let loadingStyle = "";
            let asideWidth = document.querySelector(".el-aside").offsetWidth;
            if(hasData){
                loadingStyle = hasData.offsetHeight > document.querySelector(".el-main").offsetHeight/2 ? 'screen-align' : 'empty-align';
            }
            if(asideWidth > 150){
                loadingStyle += " collapse-open";
            }else if(asideWidth > 50){
                loadingStyle += " collapse-exist";
            }
            if(value == true){
                this.loadingMethod = this.$loading({
                    lock: true,
                    target: '.paca-table__empty',
                    text: '搜尋中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(255,255,255,0.8)',
                    customClass: loadingStyle
                });
            }else{
                if(this.loadingMethod != null){
                    this.loadingMethod.close();
                }
            }
        },
    },
}
</script>